import styles from "./styles.scss";
import { NavigationTabs, PageWrapper } from "@/components";
import { Route, Routes, useParams } from "react-router-dom";
import { ContractorTab } from "@/constants";
import { map } from "lodash";
import { contractorRoutes } from "@/routes";
import { ErrorBoundary } from "@/pages";
import { FC } from "react";
import { contractorLayoutTabsConfig } from "@/pages/contractor-profile/config";
import clsx from "clsx";

export const ContractorLayout: FC = () => {
  const { tab } = useParams();

  return (
    <PageWrapper
      title="Contractor Profile"
      pageWrapperTitleClassName={styles.mainTitle}
      pageWrapperContentClassName={clsx(
        styles.pageWrapperExtra,
        tab === ContractorTab.Contractor && styles.contractor,
      )}
      extraContentClassName={styles.tabsWrapper}
      extraContent={
        <div className={styles.tabsWrapperContent}>
          <NavigationTabs<ContractorTab> items={contractorLayoutTabsConfig} />
        </div>
      }
    >
      <Routes>
        {map(contractorRoutes, (route, index) => (
          <Route
            key={index}
            path={route.path}
            element={route.element}
            errorElement={<ErrorBoundary />}
          />
        ))}
      </Routes>
    </PageWrapper>
  );
};
